//资源详情
<template>
  <div class="resource">
    <div class="resource-head">
      <div class="resource-head-img">
        <img src="../../assets/img/home/framework.png" />
      </div>
      <div class="resource-head-text">{{ $t("i18n.Resource") }}</div>
    </div>
    <div class="resource_box">
      <div class="resource_ul" v-if="resourceList && resourceList.length">
        <div
          class="resource_li"
          v-for="(item, index) in resourceList"
          :key="item.id"
        >
          <!-- {{ item }} -->
          <div class="bag" v-if="index"></div>
          <div class="left">
            <span class="imgBag" v-if="index"></span>
            <img :src="imgURL + item.thumb" />
          </div>
          <div class="right">
            <div class="number">{{ index + 1 }}</div>
            <div class="title">{{ item.title }}</div>
            <div class="content" v-html="item.contentBase.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resources",
  data() {
    return {
      imgURL: "",
      resourceList: [],
    };
  },
  created() {
    this.newsHome();
    this.imgURL = localStorage.getItem("imgURL"); //切换中英文
  },
  methods: {
    async newsHome() {
      const { data: data } = await this.$http.get("/brainpoolsIndex", {
        params: {
          page: 1,
          list_row: 10,
        },
      });
      let list = [];
      if (data.data.data && data.data.data.length) {
        data.data.data.forEach((item) => {
          if (item.category_id == "资源情况") {
            list.push(item);
          }
        });
      }
      this.resourceList = list.reverse();
    },
  },
};
</script>
<style lang="less" scoped>
.resource {
  .resource-head {
    margin: 58px 0;
    display: flex;
    justify-content: center;
    position: relative;
    .resource-head-img {
      width: 214px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .resource-head-text {
      position: relative;
      top: -10px;
      left: -7%;
      font-size: 20px;
      color: #393939;
      font-weight: 600;
    }
  }
  .resource_box {
    padding: 92px 190px;
    .resource_ul {
      .resource_li {
        display: flex;
        position: relative;

        &:not(&:last-child) {
          margin-bottom: 100px;
        }
        &:nth-child(2n) {
          .left {
            margin-right: 0px;
            padding: 50px 26px;
            width: 820px;
            height: 400px;
            .imgBag {
              width: 720px;
              height: 300px;
              position: absolute;
              top: 50px;
              left: 50px;
              border-radius: 12px;
              background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 0.84) 0%,
                rgba(255, 247, 246, 0.73) 100%
              );
            }
            img {
              position: absolute;
              top: 97px;
              width: 768px;
              height: 206px;
            }
          }
          .right {
            order: -1;
            margin-right: 100px;
          }
        }
        .bag {
          position: absolute;
          left: 222px;
          bottom: 85px;
          width: 216px;
          height: 216px;
          border-radius: 50%;
          padding: 15px;
          filter: blur(13px);
          opacity: 0.41;
          background: linear-gradient(
            126deg,
            rgba(255, 194, 181, 0.1) 0%,
            #ffc2b5 100%
          );
        }
        .left {
          width: 720px;
          margin-right: 120px;
          background: linear-gradient(180deg, #fff8f6 0%, #ffe4de 100%);
          border-radius: 12px;
          overflow: hidden;
          padding: 39px 50px 0 50px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          flex: 1;
          padding: 50px 0;
          .number {
            font-size: 28px;
            font-weight: bold;
            line-height: 39px;
            width: 68px;
            height: 68px;
            border-radius: 50%;
            background: #e06c55;
            color: #fff;
            line-height: 68px;
            text-align: center;
            // vertical-align: center;
            margin-bottom: 52px;
          }
          .title {
            margin-bottom: 36px;
            font-size: 32px;
            font-weight: bold;
            color: #393939;
            line-height: 45px;
          }
          .content {
            line-height: 40px;
          }
        }
      }
    }
  }
}
</style>
